import { render, staticRenderFns } from "./SetCoachDialog.vue?vue&type=template&id=6629a906&scoped=true"
import script from "./SetCoachDialog.vue?vue&type=script&lang=js"
export * from "./SetCoachDialog.vue?vue&type=script&lang=js"
import style0 from "./SetCoachDialog.vue?vue&type=style&index=0&id=6629a906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629a906",
  null
  
)

export default component.exports